export default __webpack_public_path__ + "static/media/hexospark-logo-rectangle.dea035f4.svg";